import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DropshipProducts from '../../components/blocks/DropshipProducts';
import ApproveVariantsModal from '../../components/modals/ApproveVariantsModal';

import {
  setDropshipProductsOffset,
  setDropshipProductsSearch,
  dropshipProductsCheck,
  dropshipProductsUncheck,
  setDropshipProductsCurrentFilter,
  setDropshipProductsSupplierId,
  getDropshipProductsBrands,
  dropshipProductsCheckAll,
  dropshipProductsCheckAllOnPage,
  dropshipProductsUncheckAll,
  dropshipProductsApproveChecked,
  dropshipProductsUnapproveChecked,
  setDropshipProductsModalOpen,
  setDropshipProductsModalClose,
  dropshipProductsApprove,
  dropshipProductsUnapprove,
  dropshipProductsSaveVariants,
} from '../../store/actions/dropshipProducts';

import { setProductFiltersSearch } from '../../store/actions/productFilters';

function DropshipProductsPermissionsContainer(props) {
  const { getDropshipBrands, unselectAll, modal, canUserDoActions, isManagedByCymbio } = props;

  useEffect(() => {
    getDropshipBrands();
    return () => {
      unselectAll();
    };
  }, [getDropshipBrands, unselectAll]);

  const shouldAllowUserToDoActions = useMemo(() => {
    return isManagedByCymbio ? !!canUserDoActions : true;
  }, [isManagedByCymbio, canUserDoActions]);
  return (
    <div>
      {modal && (
        <ApproveVariantsModal
          product={props.modalProduct}
          open={modal}
          onClose={props.closeModal}
          shouldAllowUserToDoActions={shouldAllowUserToDoActions}
          {...props}
        />
      )}

      <DropshipProducts {...props} />
    </div>
  );
}

const mapStateToProps = (state) => {
  const { retailerId } = state.role;

  const {
    data,
    count,
    perPage,
    checked,
    approved,
    search,
    offset,
    brands,
    modal,
    supplierId,
    modalProduct,
    productDetails,
    isLoading,
    isLoadingProducts,
  } = state.dropshipProducts;
  const { filters, currentFilters, currentFilterSearches } = state.productFilters;

  const { role, is_super_admin: isSuperAdmin } = state.role?.user || {};
  const canUserDoActions = isSuperAdmin && ['support', 'admin'].includes(role);
  const isManagedByCymbio = data.length && data[0].managed_by_cymbio;
  return {
    data,
    perPage,
    checked,
    approved,
    offset,
    brands,
    modal,
    modalProduct,
    productDetails,
    isLoading,
    isLoadingProducts,
    supplierId,
    retailerId,
    filters,
    currentFilters,
    currentFilterSearches,
    searchQuery: search,
    pageCount: Math.ceil(count / perPage),
    canUserDoActions,
    isManagedByCymbio,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  getDropshipBrands: () => dispatch(getDropshipProductsBrands()),
  setPage: (offset) => dispatch(setDropshipProductsOffset(offset)),
  approveChecked: () => dispatch(dropshipProductsApproveChecked(ownProps.id)),
  unapproveChecked: () => dispatch(dropshipProductsUnapproveChecked(ownProps.id)),
  productSearch: (search) => dispatch(setDropshipProductsSearch(search)),
  check: (id) => dispatch(dropshipProductsCheck(id)),
  uncheck: (id) => dispatch(dropshipProductsUncheck(id)),
  setFilter: (filter) => dispatch(setDropshipProductsCurrentFilter(filter)),
  setFilterSearch: (filter, search) => dispatch(setProductFiltersSearch(filter, search)),
  setSupplierId: (id) => dispatch(setDropshipProductsSupplierId(id)),
  selectAll: () => dispatch(dropshipProductsCheckAll()),
  selectAllOnPage: (ids) => dispatch(dropshipProductsCheckAllOnPage(ids)),
  unselectAll: () => dispatch(dropshipProductsUncheckAll),
  openModal: (product) => dispatch(setDropshipProductsModalOpen(product)),
  closeModal: () => dispatch(setDropshipProductsModalClose),
  approve: (variants) => dispatch(dropshipProductsApprove(variants)),
  unapprove: (variants) => dispatch(dropshipProductsUnapprove(variants)),
  saveVariants: () => dispatch(dropshipProductsSaveVariants(ownProps.id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DropshipProductsPermissionsContainer);

DropshipProductsPermissionsContainer.defaultProps = {
  checked: {},
};

DropshipProductsPermissionsContainer.propTypes = {
  perPage: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  filters: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  getDropshipBrands: PropTypes.func.isRequired,
  productSearch: PropTypes.func.isRequired,
  check: PropTypes.func.isRequired,
  uncheck: PropTypes.func.isRequired,
  checked: PropTypes.object,
  setFilter: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  modal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  modalProduct: PropTypes.object,
};
